import React from 'react';
import { withTranslation } from 'react-i18next';
import LinesEllipsis from 'react-lines-ellipsis';
import { TitleContainerBlock } from './style';
import { connect } from 'react-redux';

class Title extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { textAlign, text, styleParams, design, settings } = this.props;
    const titleHtmlTag =
      styleParams &&
      styleParams.fonts &&
      styleParams.fonts.headerTextFont &&
      styleParams.fonts.headerTextFont.htmlTag
        ? styleParams.fonts.headerTextFont.htmlTag
        : 'h2';
    return (
      <TitleContainerBlock
        className="faq-title"
        style={{ textAlign }}
        styleParams={styleParams}
        design={design}
        settings={settings}
      >
        <LinesEllipsis
          text={text}
          maxLine={3}
          ellipsis="..."
          trimRight={true}
          component={titleHtmlTag}
          basedOn="letters"
        />
      </TitleContainerBlock>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Title));
